import clsx from "clsx"

export default function Title ({ classNames, title }) {
    return (
        <>
            <section 
                id="title"
                className={clsx(
                    classNames,
                    'w-full py-36' 
                )}                
            >
                <div className='container m-auto grid sm:grid-cols-2 gap-4 h-full text-white z-10 pt-20 flex items-center justify-center'>
                    <div className='2xl:px-32 xl:px-24 lg:px-16 px-8'>
                        <h1 className='text-white 2xl:text-7xl xl:text-5xl lg:text-4xl text-3xl font-extrabold'>
                           {title}
                        </h1>                        
                    </div>                    
                </div>
           </section>
        </>
    )
}